// extracted by mini-css-extract-plugin
export default {"loader":"Loader__loader--cdEP8","infinite":"Loader__infinite--eXfTg","loader-animation":"Loader__loader-animation--aiL98"};